export const nest = (basePath: string, nestedPath: string) => `${basePath}${nestedPath}`
